export default __webpack_public_path__ + "images/camera-icon.d1caaffee4081c83d9ab5d8282c4eb4f.svg";